import { registerSW } from 'virtual:pwa-register';

type Listener = () => void;

let updateSW: ((reloadPage?: boolean) => Promise<void>) | null = null;
const listeners = new Set<Listener>();
let pending = false;

export function initPwaUpdate() {
  updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      pending = true;
      listeners.forEach((l) => l());
    },
  });
}

export function onUpdateAvailable(cb: Listener): () => void {
  listeners.add(cb);
  if (pending) cb();
  return () => { listeners.delete(cb); };
}

export function applyPwaUpdate() {
  if (updateSW) {
    void updateSW(true);
  } else {
    window.location.reload();
  }
}
